export default __webpack_public_path__ + "static/media/Carel 2.f263a70d.png";